import supabase from '../supabase/supabase';

const TABLE = 'guest_house_bookings_2000000000000';

export async function createBooking(values) {
  const { error } = await supabase.from(TABLE).insert({ ...values, status: 'pending' });
  if (error) throw error;
}

export async function listBookings() {
  const { data, error } = await supabase.from(TABLE).select('*').order('created_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function setBookingStatus(id, status) {
  const { error } = await supabase.from(TABLE).update({ status }).eq('id', id);
  if (error) throw error;
}

export async function removeBooking(id) {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);
  if (error) throw error;
}